module.exports = __webpack_public_path__ + "img/icon-chuti-logo.3efad916.png";